import { Link } from "react-router"; // Assuming this is correct for your router setup
import type { GalleryPhoto } from "./gallery";
import "./gallery-card.css";

export default function GalleryCard({ photo }: { photo: GalleryPhoto }) {
  // 1. Safely extract up to 3 images from the WPGraphQL nodes
  const galleryNodes = photo?.galleryFields?.galleryPhotos?.nodes || [];
  const stackImages = galleryNodes.slice(0, 3);

  // Fallback if no gallery images exist, try to find a featured image or return empty
  const hasImages = stackImages.length > 0;

  const linkOnClick = () => {
    console.log(photo.slug);
  };

  return (
    <div className="gallery-card-div">
      <Link
        to={`/gallery/${photo.slug}`}
        onClick={linkOnClick}
        className="text-decoration-none text-reset gallery-link-wrapper"
      >
        <h1 className="text-center mb-4 font-heading text-3xl">
          {photo.title}
        </h1>

        <div className="image-stack-container">
          {hasImages ? (
            stackImages.map((imgNode: any, index: number) => (
              <img
                key={index}
                src={imgNode.sourceUrl}
                alt={imgNode.altText || photo.title}
                className={`stack-image stack-index-${index} img-fluid rounded`}
              />
            ))
          ) : (
            <div className="text-center p-5 bg-light rounded">No Images</div>
          )}
        </div>
        <h3 className="font-body mt-8">
          <strong>By:</strong> {photo.author?.node?.name}
        </h3>
      </Link>
    </div>
  );
}
